export default __webpack_public_path__ + "static/customer-profile-ed9a179e3dfaf668e1a2f1eafac9043c.png";